import { useBrand } from '@bnnvara/brand';
import { SliderItemVideo } from '@bnnvara/slider';
import PropTypes from 'prop-types';
import React from 'react';

import VideoCard from '../../components/cards/VideoCard';
import Link from '../../components/Link';

const ComposableVideoSliderCard = (props) => {
  const brand = useBrand();
  const { id } = props;

  return (
    <SliderItemVideo key={id}>
      <Link href={`/videos/${id}`}>
        <VideoCard {...props} brand={brand} />
      </Link>
    </SliderItemVideo>
  );
};

ComposableVideoSliderCard.propTypes = {
  id: PropTypes.number.isRequired,
};

export default ComposableVideoSliderCard;
